import React from "react";
import { useFormContext, useWatch } from "react-hook-form";

import { AutoFormFieldProps } from "@autoform/react";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const SORTING_OPTIONS_BY_COLLECTION: Record<string, string[]> = {
  events: [
    "Recommended",
    "Popular",
    "Nearby",
    "Date",
    "RecentlyAdded",
    "Random",
    "Trending",
  ],
  artists: ["Recommended", "Popular"],
  venues: ["Recommended", "Popular", "Nearby"],
  // Cinema / theater verticals [MOO-4451].
  movies: [
    "Recommended",
    "Popular",
    "Date",
    "RecentlyAdded",
    "Random",
    "Trending",
    "Rating",
    "Nearby",
  ],
  screenings: ["Date", "Nearby", "Recommended", "Popular", "RecentlyAdded"],
  people: ["Recommended", "Popular", "Following"],
  plays: [
    "Recommended",
    "Popular",
    "Date",
    "RecentlyAdded",
    "Random",
    "Trending",
  ],
  performances: ["Date", "Nearby", "Recommended", "Popular", "RecentlyAdded"],
  show_genres: ["Recommended", "Popular"],
};

export const SortingField: React.FC<AutoFormFieldProps> = ({
  field,
  inputProps,
  error,
  id,
  value,
}) => {
  const { key, ref, ...props } = inputProps;
  const form = useFormContext();
  const watchedValue = useWatch({ name: id, defaultValue: value });
  const collection: string = useWatch({ name: "queryRules.collection" }) ?? "";

  const options = SORTING_OPTIONS_BY_COLLECTION[collection] ?? [];

  React.useEffect(() => {
    if (watchedValue && !options.includes(watchedValue)) {
      form.setValue(id, options[0] ?? "", { shouldDirty: true });
    }
  }, [collection]);

  return (
    <Select
      {...props}
      onValueChange={(value) => {
        const syntheticEvent = {
          target: { value, name: id },
        } as React.ChangeEvent<HTMLInputElement>;
        props.onChange(syntheticEvent);
      }}
      value={watchedValue}
    >
      <SelectTrigger id={id} className={error ? "border-destructive" : ""}>
        <SelectValue placeholder="Select sorting" />
      </SelectTrigger>
      <SelectContent>
        {options.map((option) => (
          <SelectItem key={option} value={option}>
            {option}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
